





















































































































































import Vue from 'vue';
import _ from 'lodash';
import store from '@/store';
import { mapState, mapGetters } from 'vuex';
import { ViewpointDao } from "@/api/ViewpointDao";
import ButtonWithConfirmation from "@/components/common/button-with-confirmation.vue";

var apiDao: ViewpointDao = new ViewpointDao();

export default Vue.extend({

  name: 'TeamSelector',

  components: {
    ButtonWithConfirmation,
  },

  props: {
    teamsProp: {
      type: Array,
      default: () => ([]),
    },
    teamProp: {
      type: Object,
      default: () => ({}),
    },
    selectedTeamIdProp: {
      type: String,
      default: '',
    },
    selectOptions: {
      type: Object,
      default: () => ({
        label: 'Please Select an Item',
      }),
    },
    authorizedActions: {
      type: Array,
      default: () => ([]),
    },
  },

  data() {
    return {
      team: this.teamProp as any,
      teamForm: {
        name: '',
        description: ''
      } as any,
      selectedTeamId: this.selectedTeamIdProp as string,
      teams: this.teamsProp,
      dialogIsEdit: false,
      dialogTitle: '',
      dialog:  false,
      loading:  false,
      nameRules: [
        (v: string) => !!v || 'Team name is required'
      ],
      valid: true,
      message: 'Your Team is being created ...',
      showMessage: false,
      formSubject: '' as any,
      ruleSubject: [
        (v: any) => !!v || '"Team Name" is required',
        (v: any) =>
          (v && v.length <= 100) ||
          '"Team Name" must be less than 100 characters'
      ],
      formBody: '' as any,
      ruleBody: [
        // (v: any) => !!v || '"Description" is required',
        (v: any) =>
          ( !v || (v.length <= 500)) ||
          '"Description" must be less than 500 characters'
      ],
    };
  },

  created() {
    console.log('[ Team Selector created() ]');
    // this.loadTeams();
  },

  mounted() {
  },

  watch: {

    teamsProp(newVal, oldVal) {
      this.teams = newVal;
    },

    teamProp(newVal, oldVal) {
      this.team = newVal;
    },

    isUpdating(newVal, oldVal) {
      console.log("[ TEAM CREATE ]: oldVal-" + oldVal + " newVal-" + newVal);
      if (!newVal && oldVal && !!this.errorMessage) {
        this.message = this.errorMessage + '<br />Please try again in a few minutes.';
        setTimeout(() => this.showMessage=false, 5000);
      } else if (!newVal && oldVal && !this.errorMessage) {
        this.showMessage = false;
        this.dialog = false;
        // this.clearForm();
      }
    },

  },

  computed: {
    
     ...mapGetters([
      'getUserId',
      'getPackageId',
      'getIsLoggedIn',
      'getInstanceId',
      'getVpInstances',
      'getVpInstancesCount',
      'getVpInstanceList',
      'getVpInstanceListCount',
      'getVpGroups',
      'getVpGroupsCount',
      'getVpGroupsList',
      'getVpGroupsListCount',
      'getVpGroupInstances',
      'getVpGroupInstancesCount',
      'getVpGroupInstancesList',
      'getVpGroupInstancesListCount'
    ]),

    filteredTeams(): any {
      let filteredTeams: any[] = _.cloneDeep(this.teams);
      const userId: string = this.getUserId;
      for (const team of filteredTeams) {
        if (team.ownerUserId == userId) {
          team.name = '☆ ' + team.name + ' (' + team.viewpoints.length + ')';
        } else {
          team.name = team.name + ' (' + team.viewpoints.length + ')';
        }
      }
      return filteredTeams;
    },

    isValid(): boolean {
      return (this.valid && !!this.teamForm.name);
    },

    inputForm(): Vue & { reset: () => void } {
      return this.$refs.form as Vue & { reset: () => void }
    },

    errorMessage(): string {
      return this.$store.getters.getVpErrorMessage;
    },

    isUpdating(): any {
      return this.$store.getters.getVpUpdating;
    },

    filteredAuthorizedActions(): any[] {
      let authorizedActions: any[] = this.authorizedActions;
      const userId: string = this.getUserId;
      if (this.team.ownerUserId != userId) {
        authorizedActions = ['add'];
      }
      return authorizedActions;
    },

  },

  methods: {

    isAuthorized(action: string): boolean {
      return this.filteredAuthorizedActions.includes(action);
    },

    teamSelected(e: any = null) {
      console.log(e);
      if (e) {
        this.$emit('team-selected', e)
      } else {
        this.$emit('team-selected', null)
      }
    },

    createTeamDialog() {
      this.dialogIsEdit = false;
      this.teamForm = {
        name: '',
        description: ''
      };
      this.dialogTitle = 'Create a New Team'
      this.dialog = true;
    },

    createTeam() {
      if (this.teamForm.name) {
        this.message = 'Your Team is being created ...';
        this.showMessage = true;
        let payload: any = {
          name: this.teamForm.name,
        };
        if (this.teamForm.description) {
          payload.description = this.teamForm.description;
        }
        store.dispatch("createTeam", payload);
        console.log('CREATED Team');
      }
    },

    editTeamDialog() {
      this.dialogIsEdit = true;
      if (this.team.name) { this.teamForm.name = this.team.name; }
      if (this.team.description) { this.teamForm.description = this.team.description; }
      this.dialogTitle = 'Edit your Team'
      this.dialog = true;
    },

    editTeam() {
      if (this.teamForm.name) {
        let payload: any = _.cloneDeep(this.team);
        this.message = 'Your Team is being updated ...';
        this.showMessage = true;
        payload.name = this.teamForm.name;
        if (this.teamForm.description) {
          payload.description = this.teamForm.description;
        }
        store.dispatch("editTeam", payload);
        console.log('editTeam() > Store > editTeam():');
        console.log(payload);
      }
    },
    
    deleteTeam() {
      console.log('DELETED Team');
      // const packageId = this.getPackageId;
      // const teamId = this.selectedTeamId;
      // if (packageId && teamId) {
      //   apiDao.deleteTeam(packageId, teamId);
      // }
    },

    validate() {
      return (this.$refs.form as Vue & { validate: () => boolean }).validate();
    },

    clearForm() {
      this.inputForm.reset();
    }
    
  },


});

